package components

import common.ECssClasses
import core.extensions.toClassName
import core.ionic.IonCol
import core.ionic.IonRow
import csstype.BackgroundImage
import csstype.BackgroundPosition
import csstype.BackgroundRepeat
import csstype.BackgroundSize
import csstype.FontWeight
import csstype.NamedColor
import csstype.Overflow
import csstype.Position
import csstype.Position.Companion.absolute
import csstype.TextAlign
import csstype.minus
import csstype.number
import csstype.pct
import csstype.px
import emotion.react.css
import module.home.SliderObject
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.useState

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 18.10.22
 * Author : marcusspors
 */

external interface SliderRowProps : Props {
    var mTitle: String?
    var mObjectList: List<SliderObject>
    var mSliderIterator: Int
}

val SliderRow = FC<SliderRowProps> { props ->

    var mTitle by useState(props.mTitle ?: "")
    var mObjectList = props.mObjectList
    var mSliderIterator = props.mSliderIterator

    IonRow {
        css(ECssClasses.SLIDER_IMAGE_ROW.toClassName(), ECssClasses.FULL_WIDTH_ROW.toClassName()) {
            flexShrink = number(1.0)
            overflow = Overflow.hidden
        }
        IonCol {
            size = "12"
            css(ECssClasses.FULL_WIDTH_COL.toClassName()) {}
            ReactHTML.div {
                css {
                    width = 100.pct
                    height = 100.pct
                }
                /* ReactHTML.div {
                     css {
                         position = Position.absolute
                         top = 6.px
                         right = 26.px
                         width = 100.pct
                         height = (100.pct-12.px)
                         zIndex = integer(-2)
                         opacity = number(0.25)
                         borderRadius = "50% / 50%".unsafeCast<BorderRadius>()
                         borderTopLeftRadius = 0.px
                         borderTopRightRadius = 0.px
                         backgroundColor = EColors.GRAY.toColor()
                     }
                 }
                 ReactHTML.div {
                     css {
                         position = Position.absolute
                         top = 12.px
                         left = 8.px
                         width = 100.pct
                         height = (100.pct-12.px)
                         zIndex = integer(-1)
                         opacity = number(0.25)
                         borderRadius = "50% / 50%".unsafeCast<BorderRadius>()
                         borderTopLeftRadius = 0.px
                         borderTopRightRadius = 0.px
                         backgroundColor = EColors.GRAY.toColor()
                     }
                 }*/
                mObjectList.forEach {
                    ReactHTML.div {
                        id = "slider-image"
                        css(classNames = arrayOf(ECssClasses.FADE_IN.toClassName())) {
                            position = absolute
                            opacity = if (it.mSliderIterator == mSliderIterator % 4) number(1.0) else number(0.0)
                            width = 100.pct
                            height = (100.pct - 12.px)
                            marginBottom = 12.px
                            //borderRadius = "50% / 50%".unsafeCast<BorderRadius>()
                            borderTopLeftRadius = 0.px
                            borderTopRightRadius = 0.px
                            backgroundImage = "url('${it.mSliderImage}')".unsafeCast<BackgroundImage>()
                            backgroundRepeat = "no-repeat".unsafeCast<BackgroundRepeat>()
                            backgroundPosition = "bottom".unsafeCast<BackgroundPosition>()
                            backgroundSize = BackgroundSize.cover
                        }
                    }
                }
                /*ReactHTML.div {
                    css {
                        position = Position.absolute
                        top = 0.px
                        width = 100.pct
                        height = 166.px
                        backgroundImage =  "linear-gradient(rgba(0,0,0,0.60), rgba(0,0,0,0))".unsafeCast<BackgroundImage>()
                    }
                }*/
                ReactHTML.div {
                    id = "slider-font"
                    css {
                        position = Position.absolute
                        width = 100.pct
                        top = 58.px
                        textAlign = TextAlign.center
                        color = NamedColor.white
                        fontWeight = "500".unsafeCast<FontWeight>()
                        fontSize = 28.px
                    }
                    +mTitle
                }
            }
        }
    }
}